import { render, staticRenderFns } from "./CreateFirstGallery.vue?vue&type=template&id=27cf2f80&"
import script from "./CreateFirstGallery.vue?vue&type=script&lang=js&"
export * from "./CreateFirstGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports